import { ChannelIconType } from '@op/components/ChannelLabel';

/**
 * API 渠道名 → ChannelLabel icon key 特殊映射
 * 仅保留 toLowerCase() 后仍无法匹配的渠道名
 * 普通渠道（如 YouTube → youtube）直接 lowercase 即可，无需在此维护
 */
export const CHANNEL_NAME_SPECIAL_MAP: Record<string, ChannelIconType> = {
  'google ads(admob)': 'admob',
  'google ads': 'admob',
  'meta': 'meta_store',
};
